import apiClient from '../utils/apiClient';

const Service = '/Service';

// Get all service settings
export const getAllServiceSettings = async () => {
  try {
    const response = await apiClient.get(`${Service}/Settings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service settings:', error);
    throw new Error(
      error.response?.data?.message || 'Error fetching service settings'
    );
  }
};

// Get all service summaries (if needed)
export const getAllServiceSummaries = async () => {
  try {
    const response = await apiClient.get(`${Service}/Summary`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service summaries:', error);
    throw new Error(
      error.response?.data?.message || 'Error fetching service summaries'
    );
  }
};

// Create a new service setting
export const createServiceSetting = async serviceSettingData => {
  try {
    const response = await apiClient.post(
      `${Service}/Settings`,
      serviceSettingData
    );
    return response.data;
  } catch (error) {
    console.error('Error creating service setting:', error);
    throw new Error(
      error.response?.data?.message || 'Error creating service setting'
    );
  }
};

// Update an existing service setting
export const updateServiceSetting = async (id, serviceSettingData) => {
  try {
    const response = await apiClient.put(
      `${Service}/Settings`,
      serviceSettingData,
      { params: { id } }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating service setting:', error);
    throw new Error(
      error.response?.data?.message || 'Error updating service setting'
    );
  }
};

// Delete a service setting by ID
export const deleteServiceSettingById = async id => {
  try {
    const response = await apiClient.delete(`${Service}/Settings`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting service setting:', error);
    throw new Error(
      error.response?.data?.message || 'Error deleting service setting'
    );
  }
};

// Post service history (if needed)
export const postServiceHistory = async historyData => {
  try {
    const response = await apiClient.post(`${Service}/History`, historyData);
    return response.data;
  } catch (error) {
    console.error('Error posting service history:', error);
    throw new Error(
      error.response?.data?.message || 'Error posting service history'
    );
  }
};
